import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Calendar } from '@/components/ui/calendar'
import { Plus } from 'lucide-react'

export default function AgendaPage() {
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Agenda</h2>
          <p className="text-muted-foreground">
            Gerencie seus agendamentos e serviços
          </p>
        </div>
        <button className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90">
          <Plus className="mr-2 h-4 w-4" />
          Novo Agendamento
        </button>
      </div>

      <Card className="p-6">
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="text-xs uppercase border-b">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Cliente
                </th>
                <th scope="col" className="px-6 py-3">
                  Serviço
                </th>
                <th scope="col" className="px-6 py-3">
                  Data
                </th>
                <th scope="col" className="px-6 py-3">
                  Horário
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="px-6 py-4 font-medium">João Silva</td>
                <td className="px-6 py-4">Corte de Cabelo</td>
                <td className="px-6 py-4">22/04/2024</td>
                <td className="px-6 py-4">14:30</td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                    Agendado
                  </span>
                </td>
                <td className="px-6 py-4">
                  <button className="text-primary hover:text-primary/80 mr-2">
                    Editar
                  </button>
                  <button className="text-primary hover:text-primary/80">
                    Cancelar
                  </button>
                </td>
              </tr>
              <tr className="border-b">
                <td className="px-6 py-4 font-medium">Maria Oliveira</td>
                <td className="px-6 py-4">Limpeza de Sofá</td>
                <td className="px-6 py-4">23/04/2024</td>
                <td className="px-6 py-4">09:00</td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                    Confirmado
                  </span>
                </td>
                <td className="px-6 py-4">
                  <button className="text-primary hover:text-primary/80 mr-2">
                    Editar
                  </button>
                  <button className="text-primary hover:text-primary/80">
                    Cancelar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  )
} 